import { Box, SelectChangeEvent } from '@mui/material';
import { useContext } from 'react';

import { SelectInput } from '@/components/common/select_input/SelectInput';
import { LocaleContext } from '@/Contexts/LocaleContext';
import useUser from '@/hooks/useUser';
import { Locales } from '@/models/User';

import RowWrap from '../common/IntakeRowWrap';

function IntakeLanguageSelect() {
  const { locale, translatedText, updateLocale } = useContext(LocaleContext);

  const { updatePreferredLanguage } = useUser();

  const handleLanguageChange = async (event: SelectChangeEvent) => {
    const selectedValue = event.target.value as Locales;
    await updatePreferredLanguage(selectedValue);
    updateLocale(selectedValue);
  };

  return (
    <RowWrap>
      <Box width='100%' maxWidth='355px'>
        <SelectInput
          onChange={handleLanguageChange}
          id='preferredLanguage'
          label={translatedText.myaccount.preferredlanguage}
          value={locale != null ? locale : ''}
          selectOptions={[
            { value: 'enUS', label: 'English' },
            { value: 'esES', label: 'Español' },
            { value: 'frFR', label: 'Français' },
            { value: 'ptBR', label: 'Português' },
            { value: 'itIT', label: 'Italiano' },
          ]}
        />
      </Box>
    </RowWrap>
  );
}

export default IntakeLanguageSelect;
